// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1qWbA","label":"Completed_label__2m6JT"};